import React from 'react'
import './Footer.css'

function Footer() {
    return (
        <div className="footer">
        <div className="footerWrapper">
            
            <div className="footerMain">
                <p>Copyright&nbsp;</p>
                <p>|</p>
                <p>&nbsp; All rights reserved 2021 &nbsp;</p>
                <p>|</p>
                <a href="/">&nbsp; Privacy</a>
            </div>

            <div className="footerLinks">
                <p>Work with us</p>
                <p>Let's Talk</p>
            </div>
            
        </div>
        </div>
    )
}

export default Footer
